import * as core from '../../../../../../../core'

import { query } from './edit-change-impact-modal.query'

export const RESOURCE = {
  payload: {
    alias: 'edit.change.impact.modal',
    description:
      'Modal for editing a change impact, including linked personas (Change360)',
    name: 'Edit Change Impact Modal',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
